<template>
    <div
        v-if="computedError.type !== 'none'"
        class="flex"
        :class="{ cover: props.cover && computedError.type !== 'redirect', 'p-4': props.padding }"
    >
        <div v-if="computedError.type === 'string'">
            <span :class="messageClass">{{ computedError.value }}</span>
        </div>
        <div v-if="computedError.type === 'errors'">
            <p :class="messageClass">{{ computedError.message }}</p>
            <p>The following errors were encountered:</p>
            <ul>
                <template v-for="(errors, key) of computedError.errors" :key="key">
                    <li>{{ key }}</li>
                    <ul>
                        <li v-for="(error, index) of errors" v-html="error" :key="index"></li>
                    </ul>
                </template>
            </ul>
        </div>
        <div v-else-if="computedError.type === 'exists'">
            <span :class="messageClass">An item like this already exists.</span>
        </div>
        <div v-else-if="computedError.type === 'unknown'">
            <span :class="messageClass">An unknown error occurred.</span>
        </div>
        <div
            v-else-if="computedError.type === 'redirect'"
            class="redirect flex grow flex-col justify-center items-center gap-3 p-10"
        >
            <h2>404</h2>
            <h4>The item you're looking for could not be found.</h4>
        </div>
        <div
            v-else-if="computedError.type === 'notfound'"
            class="redirect flex grow flex-col justify-center items-center gap-3 p-10"
        >
            <h2>404</h2>
            <h4>The item you're looking for could not be found.</h4>
        </div>
        <a class="ps-2" v-if="isReportable" :underlined="false">Report issue?</a>
    </div>
    <div v-if="cover && computedError.type !== 'none'" style="min-height: 40px"></div>
</template>

<script lang="ts" setup>
import { computeError, isErrorReportable, type ErrorTypes, type ErrorComputationProps } from '@/common/utils';

const props = withDefaults(
    defineProps<{
        error?: any;
        canReport?: boolean;
        type?: 'upload';
        cover?: boolean;
        redirect?: boolean;
        messageClass?: string;
        padding?: boolean;
    }>(),
    {
        messageClass: 'text-danger',
        padding: true,
    },
);

//pending -- redirect

/**
 * Computes the error prop, which can be anything, into a format that is reportable/displayable.
 */
const computedError = computed((): ErrorTypes => {
    const errorProps: ErrorComputationProps = {
        type: props.type,
        redirect: props.redirect,
    };
    return computeError(props.error, errorProps);
});

const isReportable = computed(() => {
    return isErrorReportable(computedError.value, props.canReport);
});
</script>

<style scoped>
.cover {
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    background-color: rgba(0, 0, 0, 0.2);

    pointer-events: all;
    z-index: 1;
}
</style>
